import React from "react"
import NoData from "../../assets/images/noData.svg"

const NoDataFound = ({
  title = "No Records Found",
  description = "There is currently no data to display.",
}) => {
  return (
    <React.Fragment>
      <div
        className={
          "py-5 d-flex flex-column align-items-center justify-content-between"
        }
      >
        <img
          src={NoData}
          style={{
            maxWidth: "300px",
          }}
          alt="Record not found"
        />
        <h4
          style={{
            color: "#000000",
            fontSize: "32px",
            fontWeight: "600",
            marginTop: "15px",
            marginBottom: "5px",
            textAlign: "center",
          }}
        >
          {title}
        </h4>
        <p
          style={{
            color: "#000000",
            textAlign: "center",
            fontSize: "16px",
          }}
        >
          {description}
        </p>
      </div>
    </React.Fragment>
  )
}

export default NoDataFound
